import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';
import { RootState } from 'store';
import { Pagination } from 'store/interfaces';
import { API_CUSAT } from 'constants/api';
import { storeName } from '../config';
import { CusatDataItem } from '../interfaces';
import { buildCusatQuery } from './buildCusatQuery';

export const getCusatList = createAsyncThunk<{
  list: CusatDataItem[];
  pagination: Pagination;
}>(`${storeName}/getList`, async (_, thunkAPI) => {
  const {
    cusat: { filters, sort, pagination },
  } = thunkAPI.getState() as RootState;

  return api.axios
    .get(
      `${API_CUSAT}?${buildCusatQuery(filters, sort, {
        page: pagination.page || 1,
        limit: pagination.limit,
      })}`,
    )
    .then((res) => res.data)
    .catch((e) => thunkAPI.rejectWithValue(e.response?.data));
});
